import Backdrop from "@mui/material/Backdrop";
import {
  Box,
  Typography,
  Stack,
  styled,
  boxClasses,
  IconButton,
  Button,
} from "@mui/material";
import AppModal from "@/components/AppModal";
import Fade from "@mui/material/Fade";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import {getCardList} from "@/redux/slices/card";
import axiosInstance from "@/utils/axios";
import {isEmptyString} from "@/utils/utils";
import React, {useCallback, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import RpIcon, {RpIconColor} from "@/components/RpIcon.jsx";
import {showBindEmailModal} from "@/redux/slices/app";
import {dispatch} from "@/redux/store";
import useSettings from "@/hook/useSettings";
import classes from "./index.module.css";

import {toggleFreezeCard} from "@/services";

import {CARD_STATUS, WALLET_SIGN_TEXT} from "@/constant/Constant.ts";
import {prepareCommonSignMessage} from "@/utils/web3utils";
import message from "@/pages/message";
import {useBoolean, useRequest} from "ahooks";
import styles from "@/components/BindEmailModal/BindEmailModal.module.css";
import {freeze} from "@reduxjs/toolkit";
import TwoFAModal from "@/components/TwoFAModal";
import {clearTaskRule, setTaskRuleParams} from "@/redux/slices/user";
import {VerifyAction} from "@/constant/VerifyConstant";
import Security2FA from "@/pages/security/Security2FA";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";

interface Props {
  onClose?: () => void;
  isFreeze: boolean;
  reresh: () => void;
  open: boolean;
  card: any;
}

const ModalHeader = styled(Stack)(({theme}) => {
  return {
    flexDirection: "row",
    [`& .${boxClasses.root}`]: {
      flex: 1,
      textAlign: "center",
    },
    [`& .iconfont`]: {
      cursor: "pointer",
    },
  };
});

export default function FreezeToggle(props: Props) {
  const {open, card, onComplete} = props;
  const {t} = useTranslation();
  const {settings} = useSettings();
  const [loading, setLoading] = useState(false);
  const [twoFAModalShow , twoFAModalShowOperate] = useBoolean(false);

  const isCardActive = useMemo(() => {
    return card?.cardStatus === CARD_STATUS.ACTIVE;
  }, [card])
  const isCardFreeze = useMemo(() => {
    return card?.cardStatus === CARD_STATUS.FROZEN;
  }, [card])

  const originalMessage = useMemo(() => {
    return isCardFreeze ? t("unfreeze_your_card_desc") : t("freeze_card_des");
  }, [isCardFreeze]);

  const toggleFreezeReq = useRequest(async () => {
    const res = await toggleFreezeCard(card.cardId, isCardFreeze, )
    return res
  }, { manual: true })

  const _handleClick = async (params) => {
    setLoading(true);
    try {
      const {signature, message} = params;
      const toggleFreezeCardRes = await toggleFreezeCard(
        card.cardId,
        isCardFreeze,
        signature,
        message
      );
    } finally {
      setLoading(false);
    }
  };

  const doAction = () => {
    clearTaskRule()
    if (isCardFreeze)
      setTaskRuleParams(({
        action: VerifyAction.CARD_UNFREEZE,
      }))
    else
      setTaskRuleParams(({
        action: VerifyAction.CARD_FREEZE,
      }))
    twoFAModalShowOperate.setTrue()
  }

  const applyFreezeToggle = () => {
    twoFAModalShowOperate.setFalse()
    toggleFreezeReq.runAsync().then(res => {
      enqueueSnackbar(isCardFreeze ? t('unfreeze_success') : t('freeze_success'), { variant: 'success' })
      onComplete && onComplete();
    })
  }

  return (
    <>
      <AppModal
        title={props.isFreeze ? t("unfreeze") : t("freeze")}
        open={open}
        onClose={() => {
          props?.onClose();
        }}
        closeAfterTransition
        slots={{backdrop: Backdrop}}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box className={classes.container}>
          <SimpleHeader
            title={!isCardFreeze ? t("freeze") : t("unfreeze")}
            closeButton={<RpIcon icon="close"
                                 clickable
                                 onClick={() => {
                                   props?.onClose();
                                 }}
                                 size={22} />}
            sx={{
              'border-top-left-radius': '12px',
              'border-top-right-radius': ' 12px',
            }}
          />
          {/*<Stack*/}
          {/*  className={styles.title}*/}
          {/*  direction="row"*/}
          {/*  justifyContent="space-between"*/}
          {/*>*/}
          {/*  <Box onClick={() => {props?.onClose && props?.onClose();}}><RpIcon icon="close" size={20}/></Box>*/}
          {/*  <p className={'h6'}>{!isCardFreeze ? t("freeze") : t("unfreeze")}</p>*/}
          {/*</Stack>*/}
          <Box className={classes.content}>
            {!isCardFreeze&&<Stack className={'alert-info'} direction={'row'} gap={"6px"}>
              <RpIcon icon="info-circle" size={18}/>
              <p className={'span'}>{t('freezing_trades')}</p>
            </Stack>}
            <Box className={classes.icon}>
              <img
                style={{width: '100%', height: '100%', display: 'block'}}
                src={`/images/plate/freeze-${settings.theme}.png`}/>
            </Box>
            <Typography
              sx={(theme) => {
                return {fontSize: theme.typography.pxToRem(15)};
              }}
              className={classes.desc}
            >
              {isCardFreeze ? t("unfreeze_your_card_desc") : t("freeze_card_des")}
            </Typography>
          </Box>
          <div className={classes.button}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius:"20px"
              }}
              onClick={() => {
                doAction()
              }}
            >
              {!isCardFreeze ? t("freeze") : t("unfreeze")}
            </Button>
          </div>
        </Box>
      </AppModal>
      
      <AppModal open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse}>
        <Security2FA callback={applyFreezeToggle} onClose={twoFAModalShowOperate.setFalse}/>
      </AppModal>
    </>
  );
}
